exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._39WLsFXLLp4jqX3iDjHFnI{margin:4px 6px 0 0}html[dir=rtl] ._39WLsFXLLp4jqX3iDjHFnI{margin:4px 0 0 6px}", ""]);
// Exports
exports.locals = {
	"groupFacepilePersona": "_39WLsFXLLp4jqX3iDjHFnI"
};